import { Fragment } from 'react';
import { useTranslation } from 'hooks';
import { IClientSearchData } from 'store/clientManagement';
import { Button } from 'components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from 'components/ui/dialog';
import { ClientSelector } from '../clients/ClientSelector';

interface IProps {
  isVisible: boolean;
  setIsVisible: (visibility: boolean) => void;
  selectedClient: IClientSearchData | null;
  onSelectClient: (client: IClientSearchData) => void
}

export const SelectClientModal = ({ isVisible, setIsVisible, selectedClient, onSelectClient }: IProps) => {
  const { t } = useTranslation();


  return (
    <Fragment>
      <div className="relative flex flex-col flex-1 overflow-auto h-full gap-3 rounded-lg border p-4 text-card-foreground bg-card basis-1/4">
        <div className="flex flex-col justify-between h-full w-full relative gap-6">
          <Dialog open={isVisible} onOpenChange={open => setIsVisible(open)}>
            <DialogContent className="sm:max-w-[425px] h-[90vh] overflow-auto flex flex-col">
              <DialogHeader>
                <DialogTitle>{t('component.SelectClientModal.title')}</DialogTitle>
                <DialogDescription>
                  {t('component.SelectClientModal.description')}
                </DialogDescription>
              </DialogHeader>

              <ClientSelector
                selectedClient={selectedClient}
                onClientSelected={(client) => onSelectClient(client)}
              />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </Fragment>
  );
};
